import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  title: {
    flex: '1 1 100%',
    fontWeight: 'bold',
  },
}));
